module.exports = __webpack_public_path__ + "static/media/37.e47a064.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/37.wav
// module id = 55xb
// module chunks = 0